import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAlmacen = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/almacenes/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAlmacenMutation: mutation.mutate,
    };
}